import axios from "axios";
import { toast } from "react-toastify";
export const BUILD_ENV = parseInt(process.env.BUILD_ENV);
import {URL as HTTP_URL} from "../config/http";
export const STAG_BASE_URL = "http://18.206.82.244:4300/";
export const LOCAL_BASE_URL = "http://localhost:4300/";

let URL;

if(BUILD_ENV == 0){
  URL = HTTP_URL.development.http;
}

if(BUILD_ENV == 1){
  URL = HTTP_URL.staging.http;
}

if(BUILD_ENV == 2){
  URL = HTTP_URL.prod.http;
}

export const publicRequest = axios.create({
  baseURL: URL,
});

export const userRequest = axios.create({
  baseURL: URL,
});

// Request interceptor to add token dynamically
userRequest.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.token = token;
  }
  return config;
});

userRequest.interceptors.response.use((response) => {
    if(response.data.code === 403){
       toast.warn("Session Expired! Please Re-login");
      window.location.assign("/logout");
    }
    return response;
}, (error) => {
  if(error.response?.data?.code === 401 || error.response?.data?.code === 403){
      toast.warn("Session Expired! Please Re-login");
      window.location.assign("/logout");
    }
    return Promise.reject(error);
});

export const userRequest1 = axios.create({
  baseURL: URL,
  headers: {
    "content-type": "application/json",
  },
});

// Request interceptor for userRequest1
userRequest1.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});


export const userRequestMultipart = axios.create({
  baseURL: URL,
  // Don't set content-type for FormData - browser will set it with boundary
});

// Request interceptor to add token dynamically
userRequestMultipart.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.token = token;
  }
  return config;
});

userRequestMultipart.interceptors.response.use((response) => {
  if(response.data.code === 403){
      toast.warn("Session Expired! Please Re-login");
      window.location.assign("/logout");
    }
    return response;
}, (error) => {
  if(error.response?.data?.code === 401 || error.response?.data?.code === 403){
      toast.warn("Session Expired! Please Re-login");
      window.location.assign("/logout");
    }
    return Promise.reject(error);
})

